import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Box = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 4H7C5.346 4 4 5.346 4 7V9C4 10.304 4.836 11.415 6 11.828V25C6 26.654 7.346 28 9 28H23C24.654 28 26 26.654 26 25V11.828C27.164 11.415 28 10.304 28 9V7C28 5.346 26.654 4 25 4ZM24 25C24 25.551 23.551 26 23 26H9C8.449 26 8 25.551 8 25V12H24V25ZM26 9C26 9.551 25.551 10 25 10H7C6.449 10 6 9.551 6 9V7C6 6.449 6.449 6 7 6H25C25.551 6 26 6.449 26 7V9Z" />
		<path d="M15 20H17C18.654 20 20 18.654 20 17C20 15.346 18.654 14 17 14H15C13.346 14 12 15.346 12 17C12 18.654 13.346 20 15 20ZM15 16H17C17.551 16 18 16.449 18 17C18 17.551 17.551 18 17 18H15C14.449 18 14 17.551 14 17C14 16.449 14.449 16 15 16Z" />
	</svg>
);

export default Box;
